(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixTepoForm);
  } else {
    fixTepoForm();
  }
  
  function fixTepoForm() {
    // Find the main product page form (not header forms)
    const mainProductForm = document.querySelector('main [data-product-form], .product-page [data-product-form], [data-section-type="product"] [data-product-form]');
    
    if (!mainProductForm) {
      console.warn('Main product form not found');
      return;
    }
    
    // Override TEPO's form detection
    const observer = new MutationObserver(function() {
      // If TEPO tries to use the wrong form, redirect it to the correct one
      const headerForms = document.querySelectorAll('header [data-product-form], [data-section-type="header"] [data-product-form]');
      
      headerForms.forEach(form => {
        // Temporarily remove the data attribute from header forms
        form.removeAttribute('data-product-form');
        form.setAttribute('data-header-product-form', '');
      });
      
      // Ensure main form has the attribute
      if (!mainProductForm.hasAttribute('data-product-form')) {
        mainProductForm.setAttribute('data-product-form', '');
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Run once immediately
    const headerForms = document.querySelectorAll('header [data-product-form], [data-section-type="header"] [data-product-form]');
    headerForms.forEach(form => {
      form.removeAttribute('data-product-form');
      form.setAttribute('data-header-product-form', '');
    });
  }
})();